var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-error"},[_c('c-text-field',_vm._b({attrs:{"value":_vm.value,"rules":_vm.rules,"error-message":_vm.message}},'c-text-field',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }